
import apiHelper from '../api';


export function api(taskData) {
    return apiHelper.getTaskExecutor(taskData);
}